import { Failure, Status } from '../models/common';
import { compact } from './array';

export const getFailuresFromStatuses = (statuses: Status[]): Failure[] =>
    compact(statuses.map((status) => status.failure));
